<template>
    <div class="container-fluid content-page-wrapper home-content-wrapper pb-5 min-vh-100" :class="{'loading': loading}">
        <div class="row pt-5 pb-3">
            <div class="col-12">
                <h1 class="text-primary font-weight-bold display-4 text-shadow text-center custom-text-break">{{ $t('tempLED Product Configurator') }}</h1>
                <p class="lead text-light text-center text-shadow">{{ $t('As individual as your project') }}</p>
            </div>
        </div>
        <div class="row pb-5 home-configurators-wrapper">
            <div class="col-12 mt-3 card-group">
                <div class="card shadow border-0 rounded mx-auto" v-for="product_configurator in product_configurators">
                    <router-link tag="a" :to="{ name: product_configurator.slug }">
                        <img class="card-img-top" :src="asset('productimages/' + product_configurator.picture_file_name)" :alt="product_configurator.title" v-if="product_configurator.picture_file_name">
                        <img class="card-img-top" :src="asset('images/rayline-konfigurator-2022_3.jpg')" :alt="product_configurator.title" v-else>
                    </router-link>
                    <div class="card-body bg-secondary">
                        <router-link tag="a" :to="{ name: product_configurator.slug }"><h2 class="card-title text-primary">{{ $t(product_configurator.title) }}</h2></router-link>
                        <p class="card-text text-light">{{ $t(product_configurator.description) }}</p>
                        <router-link class="btn btn-primary" tag="a" :to="{ name: product_configurator.slug }"><i class="fas fa-cogs"></i> <span>{{ $t('Configure now') }}</span></router-link>
                        <a href="https://templed.de/templed-konfigurator/" class="btn btn-outline-primary"><i class="fas fa-info-circle"></i> {{ $t('Information') }}</a>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-12 col-lg-6 mt-3">
                 <div class="card shadow border-0 rounded mx-auto disabled-configurator">
                     <img class="card-img-top" :src="asset('img/luminaire-selection-tool/RayClean-Pro-konfigurator.png')" alt="tempLED RayClan Pro">
                     <div class="card-body bg-secondary">
                         <h2 class="card-title text-primary">{{ $t('tempLED RayClean Pro') }}</h2>
                         <p class="card-text text-light">{{ $t('The cleanroom lighting for laboratories, hospitals, the beverage & food industry, greenhouses and the chip industry.') }}</p>
                         <a href="#" class="btn btn-primary disabled" @click.prevent disabled>Coming soon...</a>
                     </div>
                 </div>
             </div>-->
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';

export default {

    data() {
        return {
            loading: false,
            product_configurators: {},
        };
    },

    computed: {

        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            permissions: 'auth/permissions'
        }),

    },

    mounted() {
        this.getProductConfigurators()
    },

    methods: {

        getProductConfigurators() {
            this.loading = true;
            axios.get('/api/product_configurators')
                .then(response => {
                    this.product_configurators = response.data.data;
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                this.loading = false;
            });
        },
    },

}

</script>
<style scoped>
@media (max-width: 575.98px) {
    .custom-text-break {
        word-break: break-word; /* or use break-all depending on your preference */
    }
}
</style>
